<template>
    <div class="search-widget" tabindex="0">
        <v-text-field 
        autocomplete="off"
        v-model="searchModel"
        :label="label" 
        :placeholder="placeholder" 
        flat 
        outlined 
        clearable 
        color="secondaryDarker" 
        dense 
        hide-details 
        tile 
        :loading="searchLoading"
        @input="searchFunc"
        @focus="showDropdown = true"
        @click:clear="clearResults"
        prepend-inner-icon="mdi-magnify"></v-text-field>

        <div class="search-widget__dropdown primary pt-6" v-if="showDropdown && items.length" 
        ref="dropDown"
        >
            <infinite-scroller-vertical @scrolledTillBottom="onReachScrollBottom" style="height: 240px;" :windowTarget="false">
                <v-list dense>
                    <template v-for="(profile) in items">
                        <user-list-item 
                        :userDetail="profile" 
                        :key="profile.id" 
                        @clicked="closeDropdown"
                        ></user-list-item>
                    </template>
                    <v-skeleton-loader v-if="searchLoading" type="list-item-avatar@5" class="mt-5"></v-skeleton-loader>
                </v-list>
            </infinite-scroller-vertical>
            <v-btn class="search-close-btn" small icon absolute right top @click="closeDropdown">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </div>
        <!-- <v-autocomplete 
        :search-input.sync="searchModel"
        :items="items" 
        item-text="user.name"
        item-value="user.id"
        dense
        flat 
        outlined
        hide-selected
        clearable
        :label="label"
        color="grey" 
        hide-details
        prepend-inner-icon="mdi-magnify"
        hide-no-data
        @update:search-input="searchFunc"
        return-object
        ref="searchField">
            <template v-slot:append>
                <span></span>
            </template>
            <template v-slot:item="data">
                <user-list-item :userDetail="data.item.user" class="px-0"></user-list-item>
            </template>
        </v-autocomplete> -->
    </div>
</template>
<style scoped>
    .search-widget {
        position: relative;
    }
    .search-widget__dropdown {
        position: absolute;
        left: 0;
        top: 100%;
        width: 100%;
        box-shadow: 0 4px 6px 0 rgba(32,33,36,.28);
    }

    .search-close-btn {
        right: 0;
        top: 0;
    }
</style>
<script>
import { GET_SEARCH_LIST_PROFILE } from "@/store/actions.type"
import { CLEAR_SEARCH_LIST } from "@/store/mutations.type"
import userListItem from "@/components/list-item/list-item-user.vue"
export default {
    components: {
        userListItem
    },

    computed: {
        items() {
            return this.$store.state.search.searchList
        }
    },

    data: () => ({
        label: "Search",
        hint: '',
        placeholder: "",
        searchModel: "",
        searchLoading: false,
        searchTimeout: null,
        showDropdown: false,
        prevSearchValue: ''
    }),

    methods: {
        searchFunc() {
            if(this.searchTimeout) clearTimeout(this.searchTimeout)
            if(!!this.searchModel && /\S/.test(this.searchModel) && (this.searchModel !== this.prevSearchValue)) {
                this.searchTimeout = setTimeout(() => {
                    this.$store.commit(CLEAR_SEARCH_LIST)
                    this.fetchResults()
                    this.prevSearchValue = this.searchModel
                }, 500)
            }
        },

        fetchResults() {
            if (!this.searchLoading && !this.$store.state.search.searchListFetchCompleted) {
                this.searchLoading = true
                this.$store.dispatch(GET_SEARCH_LIST_PROFILE, {
                        key: this.searchModel
                    })
                    .then(() => {
                        this.searchLoading = false
                    })
            }
        },

        clearResults() {
            this.$store.commit(CLEAR_SEARCH_LIST)
            this.prevSearchValue = ''
        },

        onReachScrollBottom(val) {
            if(val) {
                this.fetchResults()
            }
        },

        closeDropdown() {
            this.showDropdown = false
        }
    }

}
</script>